export default __webpack_public_path__ + "static/media/depin_bg.544fbc60.gif";